import { ServerOfferStatus } from '@yoop/server-model/token-info';

/**
 * Predicate for requested offers that are not lost yet.
 * @param offer
 */
export const requestedAndNotLost: (offer: {
  offerStatus?: ServerOfferStatus;
}) => boolean = (offer: { offerStatus?: ServerOfferStatus }): boolean =>
  offer &&
  (offer.offerStatus === ServerOfferStatus.DEFAULT ||
    offer.offerStatus === ServerOfferStatus.WON_PAYMENT_PROCESSING_PENDING ||
    offer.offerStatus === ServerOfferStatus.WON_MANUAL_PAYMENT_REQUIRED);
